import { render, staticRenderFns } from "./ImgCutter.vue?vue&type=template&id=8f1473e4&scoped=true&"
import script from "./ImgCutter.vue?vue&type=script&lang=js&"
export * from "./ImgCutter.vue?vue&type=script&lang=js&"
import style0 from "./ImgCutter.vue?vue&type=style&index=0&id=8f1473e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1473e4",
  null
  
)

export default component.exports